export interface DatePreset {
    value: string;
    label: string;
    getRange: () => { start: string; end: string };
}

export interface DatePresetOption {
    value: string;
    label: string;
}

const formatDate = (date: Date): string => {
    return date.toISOString().split('T')[0];
};

export const datePresetSelectOptions: DatePresetOption[] = [
    { value: '', label: 'Select date range' },
    { value: 'last_7_days', label: 'Last 7 Days' },
    { value: 'last_30_days', label: 'Last 30 Days' },
    { value: 'this_month', label: 'This Month' },
    { value: 'last_month', label: 'Last Month' },
    { value: 'this_quarter', label: 'This Quarter' },
    { value: 'last_quarter', label: 'Last Quarter' },
    { value: 'this_year', label: 'This Year' },
    { value: 'last_year', label: 'Last Year' },
    { value: 'current_fiscal_year', label: 'Current Fiscal Year' },
];

export const getDatePresets = (): DatePreset[] => {
    const today = new Date();

    return [
        {
            value: '',
            label: 'Select date range',
            getRange: () => ({ start: '', end: '' }),
        },
        {
            value: 'last_7_days',
            label: 'Last 7 Days',
            getRange: () => {
                const end = new Date(today);
                const start = new Date(today);
                start.setDate(start.getDate() - 7);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'last_30_days',
            label: 'Last 30 Days',
            getRange: () => {
                const end = new Date(today);
                const start = new Date(today);
                start.setDate(start.getDate() - 30);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'this_month',
            label: 'This Month',
            getRange: () => {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                const end = new Date(today);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'last_month',
            label: 'Last Month',
            getRange: () => {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'this_quarter',
            label: 'This Quarter',
            getRange: () => {
                const currentQuarter = Math.floor(today.getMonth() / 3);
                const start = new Date(today.getFullYear(), currentQuarter * 3, 1);
                const end = new Date(today);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'last_quarter',
            label: 'Last Quarter',
            getRange: () => {
                const currentQuarter = Math.floor(today.getMonth() / 3);
                const lastQuarter = currentQuarter - 1;
                const year = lastQuarter < 0 ? today.getFullYear() - 1 : today.getFullYear();
                const quarter = lastQuarter < 0 ? 3 : lastQuarter;
                const start = new Date(year, quarter * 3, 1);
                const end = new Date(year, quarter * 3 + 3, 0);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'this_year',
            label: 'This Year',
            getRange: () => {
                const start = new Date(today.getFullYear(), 0, 1);
                const end = new Date(today);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'last_year',
            label: 'Last Year',
            getRange: () => {
                const start = new Date(today.getFullYear() - 1, 0, 1);
                const end = new Date(today.getFullYear() - 1, 11, 31);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
        {
            value: 'current_fiscal_year',
            label: 'Current Fiscal Year',
            getRange: () => {
                const fyStartYear =
                    today.getMonth() >= 9
                        ? today.getFullYear()
                        : today.getFullYear() - 1;
                const start = new Date(fyStartYear, 9, 1);
                const end = new Date(today);
                return { start: formatDate(start), end: formatDate(end) };
            },
        },
    ];
};
